<template>
  <div class="d-flex flex-md-row flex-column w-100" :class="isPhone ? 'gift-box-phone-item' : ''" style="gap: 20px;">
    <ModalGiftBoxFormatQuery :key="`format-query-${giftBox.id}`" :gift-box="giftBox" v-if="showQueryModal" @close="showQueryModal = false" />
    <div v-if="isPhone" class="merriweather-reg-15">
      {{ giftBox.name }}
    </div>
    <div class="gift-box-img" :class="isPhone ? 'gift-box-img-phone' : ''">
      <img :src="giftBox.photo_key" alt="Gift Box">
    </div>
    <div class="d-flex flex-column justify-content-between w-100">
      <div>
        <div v-if="!isPhone" class="merriweather-reg-20">
          {{ giftBox.name }}
        </div>
        <div v-if="isPhone" class="raleway-semi-p15">
          CONTENU DU COFFRET
        </div>
        <div class="raleway-reg-p15" v-html="giftBox.description"></div>
      </div>
      <div class="d-flex flex-column" :class="isPhone ? 'mt-3' : ''">
        <div class="d-flex align-items-center row no-gutters">
          <!-- Quantity -->
          <div class="col-6 col-md-2 d-flex flex-column gift-box-input">
            <label class="form-label text-uppercase raleway-medi-p15">Quantité</label>
            <input type="number" v-model.number="giftBox.quantity" min="1">
          </div>

          <!-- Type -->
          <div class="col-6 col-md-3 d-flex flex-column gift-box-input pl-3">
            <label class="form-label text-uppercase raleway-medi-p15">Type</label>
            <v-select
              id="format"
              class="select-item no-border"
              :class="{ 'dropdown-up': giftBox.disable_physique && !isPhone }"
              placeholder=""
              v-model="giftBox.format"
              :options="[
                { id: 'e-coffret', name: 'E-Coffret' },
                { id: 'physique', name: 'Physique' }
              ]"
              label="name"
              :reduce="option => option.id"
              :searchable="false"
              :clearable="false"
              :selectable="option => giftBox.disable_physique ? option.id === 'e-coffret' : option.id === 'e-coffret' || option.id === 'physique'"
              @open="setFormatDropdown(true)"
              @close="setFormatDropdown(false)"
            />

          </div>

          <!-- Amount -->
          <div class="col-5 col-md-3 d-flex flex-column gift-box-input" :class="isPhone ? 'pt-3' : 'pl-3'">
            <label class="form-label text-uppercase raleway-medi-p15">Montant</label>
            <v-select
              id="format"
              class="select-item no-border"
              :class="{ 'dropdown-up': isPhone }"
              placeholder=""
              v-model="giftBox.amount"
              :options="pricesList"
              label="name"
              :appendToBody="isPhone || updateMode ? false : true"
              :reduce="option => option.id"
            />
          </div>

        </div>
        <div class="row align-items-center mt-3" :class="isPhone ? '' : 'pr-3'">
          <div class="col-12 d-flex justify-content-between align-items-center">
            <div v-if="formatDropdownOpen" class="w-100">
              <div class="d-flex flex-column flex-md-row justify-content-between">
                <div class="d-flex align-items-center">
                  <img src="../../images/info-red.svg" class="pr-2 mb-3" v-set-alt/>
                  <p class="mb-0 raleway-reg-p13" :class="isPhone ? '' : 'pr-5'">Le coffret physique n’est malheureusement plus disponible. Inscrivez-vous pour ne rien manquer !</p>
                </div>
                <div class="text-nowrap" :class="isPhone ? 'justify-content-end w-100 tester' : ''">
                  <button type="submit" @mousedown.prevent class="hortense-btn-primary px-5 raleway-semi-p15" @click.prevent="openPhysiqueQueryModal()">ÊTRE INFORMÉ(E)</button>
                </div>
              </div>
            </div>

            <div v-else class="d-flex align-items-center ml-auto row" style="gap: 27px;">
              <template v-if="!updateMode">
                <button type="submit" class="hortense-btn-primary px-5 raleway-semi-p15" @click="addToCart(giftBox)">Ajouter</button>
              </template>
              <template v-else>
                <div class="link-text raleway-medi-p15" @click="removeFromCart(giftBox)">Supprimer</div>
                <button type="submit" class="hortense-btn-primary px-5 raleway-semi-p15" @click="updateCartItem(giftBox)">MODIFIER</button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ModalGiftBoxFormatQuery from '../../components/modals/ModalGiftBoxFormatQuery.vue';

export default {
  name: 'GiftBoxItem',
  components: {
    ModalGiftBoxFormatQuery
  },
  props: {
    giftBox: {
      type: Object,
      required: true
    },
    updateMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pricesList: [],
      formatDropdownOpen: false,
      showQueryModal: false
    };
  },
  beforeMount() {
    this.pricesList = [];
    for (let i = 0, val = 100; val <= 1000; i++, val += 50) {
      this.pricesList[i] = { id: val, name: `${val} €` };
    }
  },
  methods: {
    addToCart(giftBox) {
      if (giftBox.quantity > 0 && giftBox.amount > 0) {
        this.$emit('add-to-cart', giftBox);
      }
    },
    updateCartItem(giftBox) {
      if (giftBox.quantity > 0 && giftBox.amount > 0) {
        this.$emit('update-cart-item', giftBox);
      }
    },
    removeFromCart(giftBox) {
      this.$emit('remove-from-cart', giftBox.purchase_id);
    },
    setFormatDropdown(val) {
      if (this.giftBox.disable_physique) {
        this.formatDropdownOpen = val;
      }
    },
    openPhysiqueQueryModal() {
      this.showQueryModal = true;
    }
  },
  computed: {
    isPhone() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
    },
  }
};
</script>
<style scoped lang="scss">
.gift-box-img {
  height: 260px;
  width: 166px;
  img {
    height: 260px;
    width: 166px;
    object-fit: cover;
  }
}
.gift-box-input {
  input {
    border-radius: 15px;
    border: 1px solid #3B6152;
    padding: 10px;
    font-family: $Raleway;
    font-weight: 400;
    font-size: 15px;
    &:focus {
      outline: none;
    }
  }
  .select-item {
    border: 1px solid #3B6152;
    padding: 7px;
    border-radius: 15px;
    font-family: $Raleway;
    font-weight: 400;
    font-size: 15px;
    &:focus {
      outline: none;
    }
  }
}

.link-text {
  text-decoration: underline;
  color: #3B6152;
  cursor: pointer;
}
</style>
<style lang="scss">
.no-border .vs__dropdown-toggle {
  border: none !important;
  box-shadow: none !important;
  padding: 0;
  cursor: pointer;
}

.vs__dropdown-option--highlight {
  background: #3B6152 !important;
}

.vs__dropdown-menu {
  margin-top: 4px !important;
  z-index: 50 !important;
}

.vs__selected-options {
  height: 28px !important;
  white-space: nowrap !important;
}

.gift-box-img-phone {
  width: 100% !important;
  height: 309px !important;

  img {
    width: 100% !important;
    height: 309px !important;
    object-fit: cover;
  }
}

.gift-box-phone-item {
  .hortense-btn-primary {
    width: 150px !important;
    height: 42px !important;
  }
}

.dropdown-up .vs__dropdown-menu {
  bottom: 100% !important;
  top: auto !important;
}
</style>
